import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/2026/speakers/grid-top-shard.png")